import { useEffect, useRef } from "react";
import { useGLTF, useAnimations } from "@react-three/drei";
import { useTexture } from "@react-three/drei";
import { Lid } from "./Lid";
import { Bottle } from "./Bottle";
import { Spices } from "./Spices";
import { Label } from "./Label";
import { useExperienceStore } from "@/stores/useExperienceStore";
import type { AnimationClip, Texture, Mesh, Group } from "three";
import { RESOURCES } from "@/data/resources";

export type GLTFResult = {
  nodes: {
    Bottle: Mesh;
    Lid: Mesh;
    Label: Mesh;
    Spices: Mesh;
  };
  animations: AnimationClip[];
};

export type ModelProps = {
  nodes: GLTFResult["nodes"];
  textures: {
    normals: Texture;
    rough: Texture;
  };
};

useGLTF.preload(RESOURCES.bottleModel.path);
export function Model() {
  const sceneRef = useRef<Group>(null);
  const gltf = useGLTF(RESOURCES.bottleModel.path) as unknown as GLTFResult;
  const nodes = gltf.nodes as GLTFResult["nodes"];
  const animations = gltf.animations as GLTFResult["animations"];
  const { actions } = useAnimations(animations, sceneRef);
  const setModel = useExperienceStore((state) => state.setModel);
  useEffect(() => { if (!sceneRef.current || !actions || !actions["Bottle"]) return; setModel(sceneRef.current, actions); }, [actions, setModel]); //prettier-ignore

  // textures
  const normals = useTexture(RESOURCES.bottleNormal.path); //prettier-ignore
  const rough =  useTexture(RESOURCES.bottleRoughness.path); //prettier-ignore
  normals.flipY = false;
  rough.flipY = false;

  return (
    <>
      <group ref={sceneRef}>
        <group name="Scene">
          <group name="Empty">
            <Bottle nodes={nodes} textures={{ normals, rough }} />
            <Lid nodes={nodes} textures={{ normals, rough }} />
            <Label nodes={nodes} textures={{ normals, rough }} />
            <Spices nodes={nodes} />
          </group>
        </group>
      </group>
    </>
  );
}
